// extracted by mini-css-extract-plugin
export default {"selectorContainer":"styles_selectorContainer__iTGLt","svgContainer":"styles_svgContainer__4XEVL"};